"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetTranslationUrl = void 0;
const theme_kit_core_1 = require("@prezly/theme-kit-core");
const router_1 = require("next/router");
const react_1 = require("react");
const useCurrentCategory_1 = require("./useCurrentCategory");
const useCurrentStory_1 = require("./useCurrentStory");
function getAllowedTranslationVisibilityValues(story) {
    const { visibility } = story;
    switch (visibility) {
        case theme_kit_core_1.Visibility.EMBARGO:
            return [theme_kit_core_1.Visibility.EMBARGO, theme_kit_core_1.Visibility.PUBLIC];
        case theme_kit_core_1.Visibility.PRIVATE:
            return [theme_kit_core_1.Visibility.PRIVATE, theme_kit_core_1.Visibility.PUBLIC];
        case theme_kit_core_1.Visibility.CONFIDENTIAL:
            return [theme_kit_core_1.Visibility.CONFIDENTIAL, theme_kit_core_1.Visibility.PRIVATE, theme_kit_core_1.Visibility.PUBLIC];
        default:
            return [theme_kit_core_1.Visibility.PUBLIC];
    }
}
/**
 * Determine correct URL for translated stories/categories with a fallback to homepage.
 * E.g. if a story has a translation, the function will return the localized slug URL.
 * If there is no translation for the story, it will return the index page URL (`/`),
 * or empty string, if `noFallback` is set to `true` (this is useful for alternate locale links).
 */
function getTranslationUrl(locale, path, currentCategory, currentStory, noFallback) {
    if (currentCategory) {
        if ((0, theme_kit_core_1.getCategoryHasTranslation)(currentCategory, locale)) {
            return (0, theme_kit_core_1.getCategoryUrl)(currentCategory, locale);
        }
        if (noFallback) {
            return '';
        }
        return '/';
    }
    const localeCode = locale.toUnderscoreCode();
    if (currentStory && currentStory.culture.locale !== localeCode) {
        const allowedVisibilityValues = getAllowedTranslationVisibilityValues(currentStory);
        const translatedStory = currentStory.translations.find(({ culture, status, visibility }) => culture.locale === localeCode &&
            (0, theme_kit_core_1.isStoryPublished)(status) &&
            allowedVisibilityValues.includes(visibility));
        if (translatedStory) {
            return `/${translatedStory.slug}`;
        }
        if (noFallback) {
            return '';
        }
        return '/';
    }
    return path;
}
/**
 * This hook returns a function that is meant to be used in language pickers and alternate locales list for the pages.
 * `noFallback` parameter is useful for alternate language links in the `head` section of the document (so that there are no unwanted links to the homepage).
 */
function useGetTranslationUrl() {
    const { asPath } = (0, router_1.useRouter)();
    const currentCategory = (0, useCurrentCategory_1.useCurrentCategory)();
    const currentStory = (0, useCurrentStory_1.useCurrentStory)();
    return (0, react_1.useCallback)((locale, noFallback) => getTranslationUrl(locale, asPath, currentCategory, currentStory, noFallback), [asPath, currentCategory, currentStory]);
}
exports.useGetTranslationUrl = useGetTranslationUrl;
//# sourceMappingURL=useGetTranslationUrl.js.map